module.exports = __webpack_public_path__ + "img/21.2.TN.19aac92d.png";